import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserMinus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "2 2 20 20",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 8,
			r: 3.25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M12.25 19.25H6.94953C5.77004 19.25 4.88989 18.2103 5.49085 17.1954C6.36247 15.7234 8.23935 14 12.25 14"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M19.25 17L15.75 17"
		})
	]
});
export default SvgUserMinus;
